import { PaginationQueryParamsSchema } from '@terra/shared-dto-types';
import { ScopeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';
import {
  externalAssetListGroupsField,
  externalAssetListOrderingFields,
} from './external-asset-list-ordering.schema';
import {
  AssetDetectionMetricsSchema,
  ExternalNetworkDiscoverySourceTypeSchema,
} from './external-network-asset.schema';

export const StorageServicePublicAccessSchema = z.enum([
  'PUBLIC',
  'RESTRICTED',
  'UNKNOWN',
]);

export const StorageServiceDtoSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  name: z.string(),
  provider: z.string(),
  accountRef: z.string(),
  endpointHost: z.string(),
  resourceId: z.string(),
  region: z.string().nullable(),
  publicAccess: StorageServicePublicAccessSchema,
  websiteEnabled: z.boolean(),
  scope: ScopeSchema,
  cloudProvider: z.string().nullable(),
  cloudAccountRef: z.string().nullable(),
  cloudResourceId: z.string().nullable(),
  lastSeenAt: z.coerce.date().nullable(),
  postureCheckedAt: z.coerce.date().nullable(),
  deprovisionedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  detectionMetrics: AssetDetectionMetricsSchema.optional(),
  sourceType: ExternalNetworkDiscoverySourceTypeSchema.nullable().optional(),
});

export const StorageServiceListQuerySchema = PaginationQueryParamsSchema.extend(
  {
    ...externalAssetListOrderingFields('STORAGE_SERVICE'),
    provider: z.string().optional(),
    publicAccess: StorageServicePublicAccessSchema.optional(),
    search: z.string().optional().describe('Free-text search'),
    region: z.string().optional(),
    cloudProvider: z.string().optional(),
    scope: ScopeSchema.optional(),
    createdStartDate: z.coerce.date().optional(),
    createdEndDate: z.coerce.date().optional(),
  },
);

export const StorageServiceListResponseSchema = z.object({
  data: z.array(StorageServiceDtoSchema),
  total: z.number(),
  ...externalAssetListGroupsField,
});
